/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import {
  Button,
  Col,
  Form,
  Row,
  Table,
  Card,
  InputGroup
} from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import Loader from '../../atoms/Loader'
import TablePagination from '../../atoms/Table/TablePagination.jsx'
import { RotateCw, Search } from 'lucide-react'
import toast, { Toaster } from 'react-hot-toast'

const cardFilterStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  padding: '1.5rem',
  marginBottom: '1.5rem'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function MasterAccessPage() {
  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [url, setUrl] = useState('')

  const [debouncedName, setDebouncedName] = useState('')
  const [debouncedCode, setDebouncedCode] = useState('')
  const [debouncedUrl, setDebouncedUrl] = useState('')

  const [access, setAccess] = useState([])
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const [loading, setLoading] = useState(false)

  const headerTitleStyle = {
    color: '#343a40',
    fontSize: '24px',
    fontWeight: '700'
  }

  const loadAccess = async () => {
    setLoading(true)
    try {
      const res = await api.get(`/cms/access/list`, {
        params: {
          name: debouncedName,
          code: debouncedCode,
          slug: debouncedUrl,
          per_page: meta.per_page,
          page: meta.current_page
        }
      })
      setLoading(false)

      setMeta(res.data.metadata)
      setAccess(res.data.data)
    } catch (err) {
      setLoading(false)
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedName(name)
    }, 1000)
    return () => clearTimeout(handler)
  }, [name])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedCode(code)
    }, 1000)
    return () => clearTimeout(handler)
  }, [code])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedUrl(url)
    }, 1000)
    return () => clearTimeout(handler)
  }, [url])

  useEffect(() => {
    if (meta.current_page !== 1) {
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    } else {
      loadAccess()
    }
  }, [debouncedName, debouncedCode, debouncedUrl, meta.per_page])

  useEffect(() => {
    loadAccess()
  }, [meta.current_page])

  function handleOnChangeMeta(e) {
    const perPageValue = parseInt(e.target.value, 10)
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: perPageValue,
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    const selectedPage = data.selected + 1
    setMeta((prevMeta) => ({ ...prevMeta, current_page: selectedPage }))
    window.scrollTo(0, 0)
  }

  const resetFilter = () => {
    setName('')
    setCode('')
    setUrl('')
    setDebouncedName('')
    setDebouncedCode('')
    setDebouncedUrl('')
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const columns = [
    { label: 'Access Head', key: 'head' },
    { label: 'Access Code', key: 'code' },
    { label: 'Access Name', key: 'name' },
    { label: 'URL', key: 'slug' },
    { label: 'Sequence', key: 'sequence' }
  ]

  return (
    <div className="container-fluid px-4 mb-5">
      <Row className="mb-4 align-items-center">
        <Col>
          <h3 style={headerTitleStyle}>Master Access</h3>
        </Col>
        <Col className="text-end">
          <Button
            variant="light"
            className="text-secondary fw-bold rounded px-3 border"
            onClick={resetFilter}
            style={{ fontSize: '0.85rem' }}
          >
            <RotateCw size={16} className="me-2" />
            Reset Filters
          </Button>
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row className="gy-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Search Code</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRight: 'none',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                >
                  <Search size={16} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={code}
                  onChange={(e) => {
                    setCode(e.target.value)
                  }}
                  placeholder="Enter code..."
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Search Name</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRight: 'none',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                >
                  <Search size={16} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value)
                  }}
                  placeholder="Enter name..."
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label style={labelStyle}>Search URL</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRight: 'none',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                >
                  <Search size={16} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  value={url}
                  onChange={(e) => {
                    setUrl(e.target.value)
                  }}
                  placeholder="Enter url..."
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                />
              </InputGroup>
            </Form.Group>
          </Col>
        </Row>
      </Card>

      <Row>
        <Col md={12}>
          <Table
            responsive
            hover
            className="shadow-sm bg-white"
            style={{
              fontSize: '0.9rem',
              borderRadius: '12px',
              overflow: 'hidden'
            }}
          >
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columns.map((col, idx) => (
                  <th
                    key={idx}
                    className="p-2 align-middle"
                    style={tableHeaderStyle}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={5} className="p-5 text-center">
                    <Loader />
                  </td>
                </tr>
              )}
              {!loading && access.length === 0 && (
                <tr>
                  <td
                    colSpan={5}
                    className="p-5 text-center text-muted fw-bold"
                  >
                    No Data Available
                  </td>
                </tr>
              )}
              {!loading &&
                access.map((acc, index) => {
                  return (
                    <tr
                      key={acc.id || index}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      <td className="p-2 align-middle">{acc?.head}</td>
                      <td className="p-2 align-middle">{acc?.code}</td>
                      <td className="p-2 align-middle">{acc?.name}</td>
                      <td className="p-2 align-middle">{acc?.slug}</td>
                      <td className="p-2 align-middle">{acc?.sequence}</td>
                    </tr>
                  )
                })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} className="p-3 border-top-0">
                  <TablePagination
                    meta={meta}
                    handleOnChangeMeta={handleOnChangeMeta}
                    handlePageChange={handlePageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Col>
      </Row>

      <Toaster />
    </div>
  )
}

export default MasterAccessPage
